import { z } from 'zod';
import type { I18n } from '@lingui/core';

export const getDocumentFormSchema = (i18n: I18n) => {
  return z.object({
    name: z
      .string()
      .min(1, i18n._({ id: 'documents.validation.nameRequired', message: 'Name is required' }))
      .max(255, i18n._({ id: 'documents.validation.nameTooLong', message: 'Name is too long' })),
    description: z.string().max(2000).optional(),
    confidentiality: z
      .string()
      .min(1, i18n._({ id: 'documents.validation.confidentialityRequired', message: 'Confidentiality level is required' })),
    category: z
      .string()
      .min(1, i18n._({ id: 'documents.validation.categoryRequired', message: 'Category is required' })),
    is_published: z.boolean().default(false),
    display_targets: z.array(z.string()).default([]),
  });
};

export type DocumentFormSchemaType = z.infer<ReturnType<typeof getDocumentFormSchema>>;
/**
 * The schema's INPUT shape. Keys with a `.default()` are optional going in and
 * required coming out, so forms use `useForm<DocumentFormInput, unknown, DocumentFormSchemaType>`
 * — `zodResolver`'s `Resolver<Input, …, Output>` is not assignable to
 * `Resolver<Output, …, Output>`.
 */
export type DocumentFormInput = z.input<ReturnType<typeof getDocumentFormSchema>>;
